export default "__VITE_ASSET__u49mHU8x__"